import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImportField, ImportService} from "../import.service";
import {FormGroup} from "@angular/forms";
import {ImportFieldDialogData} from "../../../../core/definitions/import-field-dialog.data";

@Component({
    selector: 'app-edit-import-field-dialog',
    templateUrl: './edit-import-field-dialog.component.html',
    styleUrls: ['./edit-import-field-dialog.component.scss'],
    standalone: false
})
export class EditImportFieldDialogComponent implements OnInit {
  // Injections
  public data: ImportFieldDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<EditImportFieldDialogComponent> = inject(MatDialogRef);
  private readonly importService: ImportService = inject(ImportService);

  columns: string[];
  importField: ImportField;
  importFieldSet = false;
  formGroup: FormGroup;

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.setImportField();
  }

  close() {
    this.dialogRef.close(this.importField);
  }

  isInvalid() {
    let invalid = false;
    for (const controlName in this.formGroup.controls) {
      const control = this.formGroup.controls[controlName];
      if (control.invalid) {
        invalid = true;
        break;
      }
    }
    return invalid;
  }

  private setImportField() {
    this.columns = this.data.columns;
    this.importField = this.data.importField;
    this.formGroup = this.importService.createFormGroup(this.importField);
    this.importFieldSet = true;
  }


}
